module.exports = __webpack_public_path__ + "static/media/onboarding-dashboard.fe7eb043.png";